// extracted by mini-css-extract-plugin
export var leftAlign = "_g-2";
export var popper = "_g-0";
export var subtitle = "_g-1";